import { useQuery } from '@hooks/reactQuery';

import { getOperationWindowRules } from '@api/operationWindowRules';

import { extractQueryParams } from '@utils/common';

import { IOperationWindowRulesDTO } from '@interfaces/cmModule/dto/operationWindowRulesDTO';
import { IOperationWindowRule } from '@interfaces/cmModule/operationWindowRules';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { OPERATION_WINDOW_RULES } from '@constants/queryKeys';

interface IUseQueryOperationWindowRules {
	operationWindowRules: IOperationWindowRule[];
	countOfRecords: number;
	isLoadingOperationWindowRules: boolean;
}

const useQueryOperationWindowRules = (params: IOperationWindowRulesDTO): IUseQueryOperationWindowRules => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [OPERATION_WINDOW_RULES, params],
		queryFn: extractQueryParams(getOperationWindowRules),
		enabled: [!!params.page, !!params.pageSize],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		operationWindowRules: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingOperationWindowRules: (!!data && isLoading) || isFetching,
	};
};

export default useQueryOperationWindowRules;
